<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm3>
            <v-text-field
              name="code"
              label="Code"
              type="text"
              class="mr-1"
              v-model="queryParams.code"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="accName"
              label="Acccount Name"
              type="text"
              class="mr-1"
              v-model="queryParams.accName"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="accountheadName"
              label="Account Head Name"
              type="text"
              class="mr-1"
              v-model="queryParams.accountheadName"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch()">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex 12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="accountList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td @click="setAccount(props.item)">
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.accName }}</td>
                <td>{{ props.item.accTypeName }}</td>
                <td>{{ props.item.nature }}</td>
                <td>{{ props.item.accounthead.accountName }}</td>
                <td>{{ props.item.parentCode }}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-icon
                    v-if="props.item.status == 'ACTIVE'"
                    medium
                    color="green"
                    >check_circle</v-icon
                  >
                  <v-icon v-else medium color="red">cancel</v-icon>
                </td>
                <td></td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { chartOfAccountService } from "../../services/chart-of-account-service";

export default {
  name: "AccountListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },

  data: () => ({
    showListLoading: false,
    queryParams: {
      code: "",
      accName: "",
      accountheadName: "",
    },
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Type", value: "type" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accounthead.accountName" },
      { text: "Parent Code", value: "accountParent.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    accountList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getAccountList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams.code = "";
          this.queryParams.accName = "";
          this.queryParams.accountheadName = "";

          if (this.params) {
            this.queryParams.isParent = this.params.isParent;
          }
          this.getAccountList();
        }
      },
    },
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getAccountList();
    },

    getAccountList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      chartOfAccountService
        .getChartOfAccountList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountList = res.data.chartOfAccountList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    setAccount(account) {
      let obj = {
        id: account.id,
        code: account.code,
        name: account.accName,
      };
      this.dialogClose(obj);
    },

    dialogClose(account) {
      this.$emit("close", account);
    },
  },
};
</script>
